import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV } from "../constants/copy";

const pathMap = {
  Photography: "/photography",
  Gallery: "/gallery",
  Films: "/films",
  Blogs: "/blogs",
  About: "/about",
  "Get In Touch": "/get-in-touch",
};
const navItems = NAV.map((label) => ({ label, path: pathMap[label] }));

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-weddmac-dark/90 backdrop-blur-xl border-b border-white/5">
      {/* Desktop: 3-col layout */}
      <div
        className="
          hidden md:grid
          md:grid-cols-[1fr_auto_1fr]
          items-center
          gap-4 lg:gap-6
          px-6 lg:px-12 xl:px-16
          py-4 lg:py-5
        "
      >
        {/* LEFT : Navigation */}
        <nav className="flex items-center justify-start gap-3 lg:gap-5">
          {navItems.map(({ label, path }) => {
            const isActive =
              location.pathname === path ||
              (path !== "/" && location.pathname.startsWith(path + "/"));

            return (
              <Link
                key={path}
                to={path}
                className={`relative font-inter text-sm lg:text-base tracking-wide transition-all duration-300 py-2 ${
                  isActive
                    ? "text-weddmac-gold font-medium"
                    : "text-white/75 hover:text-weddmac-gold"
                }`}
              >
                {label}
                {isActive && (
                  <span className="absolute -bottom-1 left-0 right-0 h-px bg-weddmac-gold/60" />
                )}
              </Link>
            );
          })}
        </nav>

        {/* CENTER : Logo / Brand */}
        <Link
          to="/"
          className="
            justify-self-center
            font-cheelin
            text-3xl lg:text-5xl xl:text-6xl 2xl:text-7xl
            text-white hover:text-weddmac-gold
            transition-colors duration-300
            tracking-tight
            whitespace-nowrap
          "
        >
          WEDDMAC
        </Link>

        {/* RIGHT : Spacer */}
        <div />
      </div>

      {/* Mobile: logo + hamburger */}
      <div className="md:hidden flex items-center justify-between px-4 py-3.5">
        <Link
          to="/"
          className="font-cheelin text-2xl sm:text-3xl text-white hover:text-weddmac-gold transition-colors"
        >
          WEDDMAC
        </Link>

        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="p-2.5 rounded-lg text-white/90 hover:text-weddmac-gold hover:bg-white/5 transition-all touch-manipulation"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          <svg
            className="w-6 h-6 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {open ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <nav
          className="md:hidden flex flex-col gap-0.5 px-4 pb-4 pt-2 border-t border-white/10 bg-weddmac-dark/98 backdrop-blur-sm animate-fade-in"
          onClick={() => setOpen(false)}
        >
          {navItems.map(({ label, path }) => {
            const isActive =
              location.pathname === path ||
              (path !== "/" && location.pathname.startsWith(path + "/"));

            return (
              <Link
                key={path}
                to={path}
                className={`font-inter text-base py-3 px-4 rounded-xl transition-all duration-300 ${
                  isActive
                    ? "text-weddmac-gold bg-weddmac-gold/10 font-medium"
                    : "text-white/85 hover:bg-white/5 hover:text-white"
                }`}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      )}
    </header>
  );
}
